import cn from "classnames";
import { FormTemplate } from "components/modal/templates";
import { FileField } from "components/shared/form";
import Loader from "components/shared/loader";
import { createRequestForUploadFile } from "helpers/form";
import React from "react";
import { getListExcel, importFromExcel } from "sources/books/routeControlPoints";

export default class RouteControlPointsImportModal extends FormTemplate {
    componentDidMount() {
        this.setState({
            isLoading: false,
            file: null,
            skipItemsWithParserError: true,
            skipItemsWithValidationError: true,
            importResult: null,
        });
    }

    handleSubmit = (e) => {
        e.preventDefault();
        const { file, skipItemsWithParserError, skipItemsWithValidationError, isLoading } = this.state;
        if (!file || isLoading) {
            return;
        }
        this.setState({ isLoading: true });
        const paramsRequest = createRequestForUploadFile("file", file);
        paramsRequest.body.append("skipItemsWithParserError", String(skipItemsWithParserError));
        paramsRequest.body.append("skipItemsWithValidationError", String(skipItemsWithValidationError));
        importFromExcel(paramsRequest)
            .then((result) => {
                if (result) {
                    this.setState({ importResult: result });
                    if (result.isValid) {
                        this.props.onSuccess?.();
                    }
                }
            })
            .finally(() => {
                this.setState({ isLoading: false });
            });
    };

    toggleCheckbox = (name) => this.setState((s) => ({ [name]: !s[name] }));

    renderFormActions = () => {
        return (
            <div className="modal-window__footer modal-window__footer--between">
                <button
                    type="button"
                    className="btn btn-link p-0"
                    onClick={() => getListExcel({ preparedFilter: { id: { eq: this.props.firstItemId } } })}
                >
                    Скачать шаблон Excel
                </button>
                <div>
                    {this.renderActionCancel()}
                    {this.renderActionSend()}
                </div>
            </div>
        );
    };

    renderBodyInner = () => {
        const { file, skipItemsWithParserError, skipItemsWithValidationError } = this.state;
        return (
            <>
                <FileField
                    label="Выберите файл"
                    inputProps={{ name: "file" }}
                    value={file}
                    accept=".xlsx,.xls"
                    onChange={({ value }) => this.setState({ file: value })}
                />

                <div className="row mb-3">
                    <div className="offset-sm-4 offset-md-3 col-sm-8 col-md-9">
                        <div className="mb-2">
                            <label
                                className="d-flex align-items-center mb-0 font-size-14"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.toggleCheckbox("skipItemsWithParserError")}
                            >
                                <span
                                    className={cn("checkbox mr-2", {
                                        "checkbox--checked": skipItemsWithParserError,
                                    })}
                                />
                                Пропускать записи с ошибками парсинга
                            </label>
                        </div>
                        <div className="mb-2">
                            <label
                                className="d-flex align-items-center mb-0 font-size-14"
                                style={{ cursor: "pointer" }}
                                onClick={() => this.toggleCheckbox("skipItemsWithValidationError")}
                            >
                                <span
                                    className={cn("checkbox mr-2", {
                                        "checkbox--checked": skipItemsWithValidationError,
                                    })}
                                />
                                Пропускать записи с ошибками валидации
                            </label>
                        </div>
                    </div>
                </div>
            </>
        );
    };

    renderActionSend = () => {
        const { file } = this.state;
        const cname = cn("btn btn-brand btn-sm modal-window__footer-action", { "btn--disabled": !file });
        return <input type="submit" className={cname} value="Импортировать" disabled={!file} />;
    };

    renderImportResult = () => {
        const { importResult } = this.state;
        const { errorMessage, headerKeys, items, isValid } = importResult;

        const hasTable = headerKeys && items && items.length > 0;

        const columns = hasTable ? Object.keys(headerKeys) : [];
        const skippedCount = hasTable ? items.filter((r) => r.isSkipped).length : 0;
        const errorCount = hasTable
            ? items.filter((r) => !r.isSkipped && (r.hasParserError || r.hasValidatorError)).length
            : 0;
        const importedCount = isValid && hasTable ? items.length - skippedCount - errorCount : 0;

        return (
            <>
                <div className="modal-window__body" style={{ overflowY: "auto", maxHeight: "60vh" }}>
                    {errorMessage && <div className="alert alert-danger mb-3">{errorMessage}</div>}
                    {hasTable && (
                        <>
                            <div className="d-flex mb-3 font-size-14">
                                {isValid ? (
                                    <span className="text-success">Импортировано: {importedCount}</span>
                                ) : (
                                    <span className="text-danger">Ничего не импортировано</span>
                                )}
                                {skippedCount > 0 && <span className="text-muted ml-3">Пропущено: {skippedCount}</span>}
                                {errorCount > 0 && <span className="text-danger ml-3">С ошибками: {errorCount}</span>}
                            </div>
                            <div style={{ overflowX: "auto" }}>
                                <table className="table table-sm table-bordered font-size-12 mb-0">
                                    <thead>
                                        <tr>
                                            <th>Строка</th>
                                            <th>Статус</th>
                                            {columns.map((key) => (
                                                <th key={key}>{headerKeys[key]}</th>
                                            ))}
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {items.map((row) => {
                                            const {
                                                rowIndex,
                                                item,
                                                parserErrorMessages,
                                                validatorErrorMessages,
                                                isSkipped,
                                                hasParserError,
                                                hasValidatorError,
                                            } = row;
                                            const hasError = hasParserError || hasValidatorError;
                                            const rowClass = isSkipped
                                                ? "table-secondary"
                                                : hasError
                                                  ? "table-danger"
                                                  : isValid
                                                    ? "table-success"
                                                    : "";
                                            const statusLabel = isSkipped
                                                ? hasParserError
                                                    ? "Пропущено (ошибка парсинга)"
                                                    : "Пропущено (ошибка валидации)"
                                                : hasParserError
                                                  ? "Ошибка парсинга"
                                                  : hasValidatorError
                                                    ? "Ошибка валидации"
                                                    : isValid
                                                      ? "Импортировано"
                                                      : "Не импортировано";
                                            const allErrors = { ...parserErrorMessages, ...validatorErrorMessages };
                                            return (
                                                <tr key={rowIndex} className={rowClass}>
                                                    <td>{rowIndex}</td>
                                                    <td style={{ whiteSpace: "nowrap" }}>{statusLabel}</td>
                                                    {columns.map((key) => (
                                                        <td key={key}>
                                                            {item?.[key] ?? ""}
                                                            {allErrors[key] && (
                                                                <div className="text-danger font-size-12">
                                                                    {allErrors[key]}
                                                                </div>
                                                            )}
                                                        </td>
                                                    ))}
                                                </tr>
                                            );
                                        })}
                                    </tbody>
                                </table>
                            </div>
                        </>
                    )}
                </div>
                <div className="modal-window__footer modal-window__footer--right">{this.renderActionCancel()}</div>
            </>
        );
    };

    renderActionCancel = () => {
        const cname = "btn btn-secondary btn-sm modal-window__footer-action";
        return (
            <div className={cname} onClick={() => this.close()}>
                Закрыть
            </div>
        );
    };

    renderBody = () => {
        if (this.state.isLoading) {
            return (
                <div className="loader-wrap">
                    <Loader prefix="margin-center" />
                </div>
            );
        }
        if (this.state.importResult) {
            return this.renderImportResult();
        }
        const cname = cn("modal-window__form", {
            "modal-window__form--invalid": !this.state.isValid,
        });
        return (
            <form className={cname} onSubmit={this.handleSubmit}>
                {this.renderBodyInner()}
                {this.renderFormActions()}
            </form>
        );
    };
}
